// Global timing configuration for the application
export const FACTOID_INTERVAL_MS = 12000; // 12 seconds - time each factoid displays
